import { useContext, useEffect, useState } from 'react';
import { gql } from 'graphql-request';
import { useQuery } from '@tanstack/react-query';

import { Issue, Section, USER_ROLE } from '../../../../constants';
import config from '../../../../config';
import { byReleaseDate } from '../../../../hooks/use-issue';
import { AppContext } from '../../../../App.context';

export function useSection(id: number): GetIssuesResponse {
	const { graphQLClient, parseGraphQLClientError } = useContext(AppContext);
	const [issues, setIssues] = useState<Array<Issue>>([]);

	const isAdmin = localStorage.getItem(USER_ROLE) === 'admin';
	const cacheTime = isAdmin
		? 0
		: 1000 * 60 * (config.app?.cache?.ttl?.getAllIssues || 60);
	// variables: { id: sectionId },
	const queryKey = ['sections', id, 'issues'];
	const { isPending, error, data } = useQuery<SectionQuery>({
		queryKey,
		queryFn: async () =>
			graphQLClient.request(sectionQueryDocument, {
				id,
			}),
		staleTime: cacheTime,
		refetchInterval: cacheTime,
		gcTime: cacheTime,
	});

	useEffect(() => {
		if (!data) return;
		const { section } = data;
		if (!section) return;
		if (!section.issues) return;

		setIssues(section.issues.sort(byReleaseDate));
	}, [data]);

	return {
		isLoading: isPending,
		error: error ? parseGraphQLClientError(error) : null,
		issues,
	};
}

interface SectionQuery {
	section: Section | null;
}

interface GetIssuesResponse {
	isLoading: boolean;
	error: Error | null;
	issues: Array<Issue>;
}

export const sectionQueryDocument = gql`
	query GetSection($id: ID!) {
		section(id: $id) {
			id
			position
			name
			issues {
				id
				position
				name
				description
				cover
				externalUrl
				price
				features
				currency
				slug
				data
				releaseDate
				features
				updated
				isPaid
				created
				isPurchased
			}
		}
	}
`;
